// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Maven+Pro:400,700);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
html, body {
  margin: 0;
  padding: 0;
  height: 100vh;
  scrollbar-width: none;
  /* overflow-x: hidden; */

  margin-top: 120px; 
  min-height: 70%;
  max-height: 80% !important;
}

@media (max-width: 768px) {
 

  html {
    /* overflow: scroll;  */
    width: 100%; /* Ensure no weird width constraints */
    min-height: 100%;
    max-height: 80% !important;
    height: 100vh;
  }

  body {
    overflow-y: scroll; /* Ensure vertical scroll works on body */
    width: 100%; /* Ensure no weird width constraints */
    /* min-height: 100%;
    max-height: 80% !important;
    height: 100vh; */
  }
}


#root {
  /* min-height: 100%; */
  min-height: 100%;
  /* max-height: 100vh !important; */
  display: flex;
  flex-direction: column;
  max-width: 100%;
  /* overflow-x: hidden; */

}


footer {
  position:relative;

  bottom: 0;
  left: 0;
  width: 100%;
  padding-bottom: 4px !important;
  margin-bottom: 0 !important;
  text-align: center;
  padding: 20px;
  z-index: 9999;
}


body {
  font-family: "Maven Pro", sans-serif !important;
  padding-top: 100px;


}

.full-screen {
  padding: 8rem 0;
}

.small-text {
  color: #5b5b5b;
  font-size: 18px;
  font-weight: bold;
  padding: 8px 0px;
  border-radius: 50px;
  letter-spacing: 0.2px;
}


ul {
  margin: 0;
  padding: 0;
}

ul li {
  list-style: none;
}

a {
  font-weight: normal;
  text-decoration: none !important;
  transition: all 0.4s ease;
}

a:hover {
  color: #1ABC9C !important;
}

.navbar-brand .uil {
  font-size: 40px;
}

/* p {
  font-size: 14px;
  font-weight: 300;
  line-height: 1.5;
  color: #5b5b5b;
} */

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: bold;
  letter-spacing: -1px;
}

h1 {
  color: #212121;
  font-size: 2.8em;
  margin: 24px 0;
}

h2 {
  color: #353535;
  font-size: 2.4em;
  font-weight: bold;
}

h3 {
  color: #484848;
}

h3,
b,
strong {
  font-weight: bold;
}

.custom-btn {
  background: #eee;
  color: #5b5b5b;
  font-weight: bold;
  border-radius: 50px;
  padding: 13px 29px;
  margin-right: 5px;
  font-size: 14px;
  line-height: normal;
  overflow: hidden;
  transition: all 0.4s ease;
}

.custom-btn:hover {
  color: #1ABC9C;
}

.custom-btn.custom-btn-bg {
  background: #474559;
  color: #ffffff;
}

.custom-btn.custom-btn-bg:hover {
  background: #1ABC9C;
  color: #ffffff !important;
}

.animated {
  position: relative;
}

.animated-info {
  display: inline-block;
  vertical-align: top;
  margin-top: 5px;
  min-width: 300px;
  position: relative;
}

.animated-item {

  color: #1ABC9C;

}

.animated-item  {
  font-size: 38px;
  line-height: inherit;
  display: block;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0px;
  left: 0;
  animation: BottomTotop 6s linear infinite 0s;
}

/* .animated-item:nth-child(2n+2) {
  animation-delay: 2s;
} */

/* .animated-item:nth-child(3n+3) {
  animation-delay: 4s;
} */

/* @keyframes BottomTotop {
  0% {
    opacity: 0;
  }

  5% {
    opacity: 0;
    transform: translateY(5px);
  }

  10% {
    opacity: 1;
    transform: translateY(0px);
  }

  25% {
    opacity: 1;
    transform: translateY(0px);
  }

  30% {
    opacity: 0;
    transform: translateY(5px);
  }

  80% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
} */

.animated-item:nth-child(2) {
  animation-delay: 3s; /* Delay for the second item */
}

@keyframes BottomTotop {
  0% {
    opacity: 0;
    transform: translateY(5px);
  }

  10% {
    opacity: 1;
    transform: translateY(0px);
  }

  30% {
    opacity: 1;
    transform: translateY(0px);
  }

  40% {
    opacity: 0;
    transform: translateY(5px);
  }

  100% {
    opacity: 0;
  }
}
.navbar {
  background-color: white;
  position: fixed !important;
  top: 0;
  right: 0;
  left: 0;
  z-index: 2;
  will-change: transform;
  transition: transform 200ms linear;
  
}

.navbar[class*="-unpinned"] {
  transform: translate(0, -150%);
}

.navbar[class*="-pinned"] {
  transform: translate(0, 0);
}

.navbar[class*="headroom--not-top"] {
  background: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  padding-top: 0;
  padding-bottom: 0;
}

.navbar-brand {
  font-weight: bold;

}



.navbar-brand {
  background: #fff;
  transition: all 0.5s;
  z-index: 997;
  padding: 20px 0;
  padding-left: 35px;
  top: 40px;
}

.navbar-brand .logo {
  font-size: 25px;
  margin: 0;

  padding: 0;
  line-height: 1;
  font-weight: 700;
  letter-spacing: 1px;
  font-family: "Raleway", sans-serif;
}

.navbar-brand .logo span {
  font-size: medium;
}

.navbar-brand .logo-text {
  font-size: small;
  color: #050505;
  letter-spacing: 1px;
  font-weight: 400;
}

.navbar-brand .logo {
  color: #1ABC9C;
}

.navbar-brand .logo img {
  max-height: 50px;
  vertical-align: middle;
  border-style: none;
}

@media (max-width: 992px) {
  .navbar-brand {
    top: 0;
    padding: 15px 0;
    padding-left: 35px;
  }

  .navbar-brand .logo {
    font-size: 25px;
  }
}

@media (max-width: 576) {
  .navbar-brand {
    top: 0;
    padding: 15px 0;
    padding-left: 35px;
  }

  .navbar-brand .logo {
    font-size: 10px;
  }
}

.navbar-expand-sm .navbar-nav .nav-link {
  padding: 0 20px;
}

.nav-link {
  font-weight: bold;
  font-size: 16px;
  overflow: hidden;
}


.nav-link span {
  position: relative;
  display: inline-block;
  transition: transform 0.3s;
}

.nav-link span:before {
  position: absolute;
  top: 100%;
  content: attr(data-hover);
  transform: translate3d(0, 0, 0);
}

.navbar-light .navbar-nav .nav-link:focus,
.navbar-light .navbar-nav .nav-link:hover {

  font-weight: bold;
}

.navbar-light .navbar-nav .nav-link:focus span,
.navbar-light .navbar-nav .nav-link:hover span {
  transform: translateY(-100%);
}

.navbar-light .navbar-toggler-icon {
  background: none;
}

.navbar-toggler {
  border: 0;
  padding: 0;
  width: 32px;
  height: 32px;
  line-height: 32px;
  outline: none;
  cursor: pointer;
  margin-right: 10px;
}

.navbar-toggler:focus {
  outline: none;
}

.navbar-toggler[aria-expanded="true"] .navbar-toggler-icon:first-child {
  transform: rotate(45deg);
  top: 6px;
}

.navbar-toggler[aria-expanded="true"] .navbar-toggler-icon:nth-child(2) {
  display: none;
}

.navbar-toggler[aria-expanded="true"] .navbar-toggler-icon:last-child {
  transform: rotate(-45deg);
  bottom: 1px;
}

.navbar-toggler .navbar-toggler-icon {
  background: #212121;
  display: block;
  width: 100%;
  height: 2px;
  margin: 5px 0;
  transition: all 0.4s ease;
  position: relative;
}



.close-navbar-toggler {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
  cursor: pointer;
}

.close-navbar-toggler.collapsed {
  z-index: -1;
}

.copyright-text {
  font-size: 16px;

  font-weight: normal;
  display: block;
  margin-top: auto;
}

.color-mode {
  font-weight: bold;
  cursor: pointer;
}

.color-mode-icon {
  position: relative;
  right: 6px;
}

.color-mode-icon:after {
  font-family: 'unicons';
  content: '\\ea9f';
  font-size: 30px;
  font-weight: 300;
  font-style: normal;
}

.color-mode-icon.active:after {
  font-family: 'unicons';
  content: '\\eb65';
  font-size: 30px;
  color: #ffffff;
}

.dark-mode {
  background: #0c0c0d;
}

.dark-mode .navbar-light .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.8);
}


.dark-mode .navbar[class*="headroom--not-top"] {
  background: #0c0c0d;
  border-bottom: 1px solid #1f1f1f;
}

.dark-mode .small-text {
  background: #0d0c15;
  color: #ffffff;
}

.dark-mode .feature-card .uil,
.dark-mode .navbar-light .navbar-brand,
.dark-mode h1,
.dark-mode h2,
.dark-mode h3,
.dark-mode h4,
.dark-mode h5,
.dark-mode h6,
.dark-mode .color-mode {
  color: #ffffff;
}

.dark-mode .owl-carousel .owl-nav button.owl-next,
.dark-mode .owl-carousel .owl-nav button.owl-prev,
.dark-mode .owl-carousel button.owl-dot {
  color: #ffffff;
}

.timeline-wrapper {
  position: relative;
  padding: 22px 0;
}

.timeline-wrapper:last-child:before {
  height: 0;
}

.timeline-wrapper:before {
  content: "";
  background: #474559;
  width: 3px;
  height: 100%;
  position: absolute;
  left: 38px;
}

.timeline-yr {
  background: #474559;
  border-radius: 100%;
  position: absolute;
  width: 75px;
  height: 75px;
  line-height: 75px;
  text-align: center;
}

.timeline-yr span {
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  display: block;
  line-height: 75px;
}

.timeline-info {
  display: inline-block;
  vertical-align: top;
  max-width: 432px;
  margin-left: 6em;
}

.timeline-info small {
  color: #474559;
  font-size: 16px;
  font-weight: bold;
  display: inline-block;
  vertical-align: middle;
  margin-left: 15px;
}

.owl-carousel .owl-nav span {
  display: none;
}

.owl-carousel .owl-nav .owl-prev:before,
.owl-carousel .owl-nav .owl-next:before {
  background: none;
  padding: 0;
  display: block;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  font-family: 'unicons';
  font-size: 100px;
  line-height: normal;
}

.owl-carousel .owl-nav .owl-prev:before {
  content: '\\e833';
  left: -45px;
}

.owl-carousel .owl-nav .owl-next:before {
  content: '\\e836';
  right: -45px;
}

.owl-theme .owl-nav [class*=owl-] {
  background: none;
  border-radius: 0;
  margin: 0;
  padding: 0;
  font-size: inherit;
}

.owl-theme .owl-nav [class*=owl-]:hover {

  color: #1ABC9C;

}

.owl-theme .owl-dots .owl-dot {
  outline: none;
}

.owl-theme .owl-dots .owl-dot span {
  width: 8px;
  height: 8px;
}

.owl-theme .owl-dots .owl-dot.active span,
.owl-theme .owl-dots .owl-dot:hover span {
  background: #5b5b5b;
}

.google-map iframe {
  width: 100%;
}

.contact-form {
  position: relative;
}

.contact-form .form-control {
  background: transparent;
  border-radius: -20px;
  outline: none;
  box-shadow: none;
  font-weight: 300;
  margin: 4px 0;
  align-items: center;


}

.contact-form .form-control:not(textarea) {
  height: 40px;
}

.contact-form .form-control:hover,
.contact-form .form-control:focus {
  color: #1ABC9C;

  border-radius: -20px;

}

.contact-form .submit-btn {
  background: #1ABC9C;
 border-radius: 50px;
  color: #ffffff;
  font-weight: bold;
  border: 0;
  cursor: pointer;
  transition: all 0.4s ease;
}

.contact-form .submit-btn:hover {
  background: #474559;
}

.contact-form labels {
  margin-right: 0px;
  justify-content: flex-start;
  color: #1ABC9C;

}

.contact-info {
  background: #474559;
  border-radius: 0 0 3px 3px;
  position: relative;
  bottom: 8px;
}

.contact-info p,
.contact-info a {
  color: #f7f3f3;
}

.social-links .uil {
  color: #f7f3f3;
  font-size: 20px;
  display: block;
  margin: 5px 0;
}

.social-links .uil:hover {
  color: #1ABC9C;

}

@media (min-width: 1270px) {
  .owl-theme .owl-dots {
    position: relative;
    bottom: 50px;
  }
}

@media (max-width: 991px) {
  .full-screen {
    padding-bottom: 4rem;
  }

  .color-mode {
    display: none;
  }

  .about-image {
    margin-top: 4em;
  }

  .mobile-mt-2,
  .contact-form {
    margin-top: 4em;
  }

  .contact-info {
    padding: 0 2rem;
  }
}

@media (max-width: 767px) {
  h1 {
    font-size: 2.4em;
  }

  h2 {
    font-size: 2em;
  }

  .animated-item {
    font-size: 28px;
  }

  .navbar-collapse {
    text-align: center;
    padding-bottom: 20px;
  }

  .navbar-expand-sm .navbar-nav .nav-link {
    padding: 3px 20px;
  }
}

@media (max-width: 580px) {
  .animated-info {
    min-width: 200px;
  }

  .animated-item {
    font-size: 30px;
  }

  .custom-btn-group {
    text-align: center;
  }

  .custom-btn {
    display: block;
    margin: 10px 0;
  }

  .submit-btn {
    text-align: center;
    position: relative;
  }

  .owl-theme .owl-nav {
    display: none;
  }

  .timeline-info small {
    display: block;
    margin: 10px 0 0 0;
  }
}

@media (max-width: 320px) {
  .animated-text {
    margin-top: 0;
  }

  .submit-btn {
    text-align: center;
    position: relative;
  }

  .about-text {
    text-align: center;
  }

  .full-screen {
    padding: 4rem 0;
  }

  .mobile-block {
    display: block;
  }

  .contact-info {
    flex-direction: column;
  }

  .social-links li {
    display: inline-block;
    vertical-align: top;
  }
}


.navbar-scrolled {
  background-color: #eabdbd;
}


@media (max-width: 576px) {
  .pagination-container button {
    font-size: 0.8rem;
    padding: 0.2rem 0.4rem;
  }
}


.btn-green {
  background-color: #1ABC9C;
  color: white;
  text-wrap: nowrap;
}
.btn-secondary{
  text-wrap: nowrap;
}

.btn-green:hover {
  background-color: #2dceae;
  color: white;
}

.text-green {
  color: #1ABC9C;

}
.bk-hr{
    background-color:#474559 !important;
    color: #fff !important;
    border: 2px solid white;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-weight: bold;
    font-size: large;
    margin-top: 8px;
    display: block;

}

.button-container {
  position: relative;
}

.bt-l {
  position: absolute;
  right: 0;
}
.button-spacing{
  margin-right: 8px !important;
}
 .form-control-bg{
  background-color: #FFFFFF !important; 
 
}
.table-responsive-resume table {
  width: 100%;
  border-collapse: collapse;
}


.table-responsive-resume td {
  padding: 10px;
  text-align: left;
  vertical-align: top;
  text-wrap: wrap !important;

}
.table-responsive-resume th{
  padding: 10px;
  text-align: left;
  vertical-align: top;
  text-wrap: nowrap;
  }
.table-responsive-resume td{
  word-break: break-word;
}
@media (max-width: 768px) {
  .table-responsive-resume th,
  .table-responsive-resume td {
    display: block;
    width: 100%;
  }

  .table-responsive-resume th {
    font-weight: bold;
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
  }

  .table-responsive-resume td {
    margin-bottom: 10px;
    text-align: justify;
  }
}
.table-responsive-resume td{
  text-align: justify;
}

@media (min-width: 768px) and (max-width: 1024px) {
  body{
    margin-top: 28px !important;
  }
}

.form-check-input:checked{
  background-color: #1ABC9C;
    border-color: #1ABC9C;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";AAGA;EACE,SAAS;EACT,UAAU;EACV,aAAa;EACb,qBAAqB;EACrB,wBAAwB;;EAExB,iBAAiB;EACjB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;;EAGE;IACE,uBAAuB;IACvB,WAAW,EAAE,sCAAsC;IACnD,gBAAgB;IAChB,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,kBAAkB,EAAE,yCAAyC;IAC7D,WAAW,EAAE,sCAAsC;IACnD;;oBAEgB;EAClB;AACF;;;AAGA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,wBAAwB;;AAE1B;;;AAGA;EACE,iBAAiB;;EAEjB,SAAS;EACT,OAAO;EACP,WAAW;EACX,8BAA8B;EAC9B,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,aAAa;AACf;;;AAGA;EACE,+CAA+C;EAC/C,kBAAkB;;;AAGpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;;AAGA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;GAKG;;AAEH;;;;;;EAME,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;;AAEhB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,OAAO;EACP,4CAA4C;AAC9C;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAgCG;;AAEH;EACE,mBAAmB,EAAE,8BAA8B;AACrD;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;AACF;AACA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,MAAM;EACN,QAAQ;EACR,OAAO;EACP,UAAU;EACV,sBAAsB;EACtB,kCAAkC;;AAEpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;;AAEnB;;;;AAIA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,SAAS;;EAET,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE;IACE,MAAM;IACN,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,MAAM;IACN,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;;;AAIA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;;EAEf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;;AAGA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;;;;EASE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,6BAA6B;EAC7B,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;;AAEhB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;;;AAGrB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,cAAc;;EAEd,oBAAoB;;AAEtB;;AAEA;EACE,mBAAmB;CACpB,mBAAmB;EAClB,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;;AAEhB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;;AAEhB;;AAEA;EACE;IACE,kBAAkB;IAClB,YAAY;EACd;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;AACF;;;AAGA;EACE,yBAAyB;AAC3B;;;AAGA;EACE;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACF;;;AAGA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;;AAEhB;AACA;IACI,mCAAmC;IACnC,sBAAsB;IACtB,uBAAuB;IACvB,4DAA4D;IAC5D,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,cAAc;;AAElB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,4BAA4B;AAC9B;CACC;EACC,oCAAoC;;AAEtC;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;;AAE5B;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB;AACF;EACE,sBAAsB;AACxB;AACA;EACE;;IAEE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;AACF;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,yBAAyB;IACvB,qBAAqB;AACzB","sourcesContent":["\r\n@import url(\"https://fonts.googleapis.com/css?family=Maven+Pro:400,700\");\r\n\r\nhtml, body {\r\n  margin: 0;\r\n  padding: 0;\r\n  height: 100vh;\r\n  scrollbar-width: none;\r\n  /* overflow-x: hidden; */\r\n\r\n  margin-top: 120px; \r\n  min-height: 70%;\r\n  max-height: 80% !important;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n \r\n\r\n  html {\r\n    /* overflow: scroll;  */\r\n    width: 100%; /* Ensure no weird width constraints */\r\n    min-height: 100%;\r\n    max-height: 80% !important;\r\n    height: 100vh;\r\n  }\r\n\r\n  body {\r\n    overflow-y: scroll; /* Ensure vertical scroll works on body */\r\n    width: 100%; /* Ensure no weird width constraints */\r\n    /* min-height: 100%;\r\n    max-height: 80% !important;\r\n    height: 100vh; */\r\n  }\r\n}\r\n\r\n\r\n#root {\r\n  /* min-height: 100%; */\r\n  min-height: 100%;\r\n  /* max-height: 100vh !important; */\r\n  display: flex;\r\n  flex-direction: column;\r\n  max-width: 100%;\r\n  /* overflow-x: hidden; */\r\n\r\n}\r\n\r\n\r\nfooter {\r\n  position:relative;\r\n\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  padding-bottom: 4px !important;\r\n  margin-bottom: 0 !important;\r\n  text-align: center;\r\n  padding: 20px;\r\n  z-index: 9999;\r\n}\r\n\r\n\r\nbody {\r\n  font-family: \"Maven Pro\", sans-serif !important;\r\n  padding-top: 100px;\r\n\r\n\r\n}\r\n\r\n.full-screen {\r\n  padding: 8rem 0;\r\n}\r\n\r\n.small-text {\r\n  color: #5b5b5b;\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  padding: 8px 0px;\r\n  border-radius: 50px;\r\n  letter-spacing: 0.2px;\r\n}\r\n\r\n\r\nul {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nul li {\r\n  list-style: none;\r\n}\r\n\r\na {\r\n  font-weight: normal;\r\n  text-decoration: none !important;\r\n  transition: all 0.4s ease;\r\n}\r\n\r\na:hover {\r\n  color: #1ABC9C !important;\r\n}\r\n\r\n.navbar-brand .uil {\r\n  font-size: 40px;\r\n}\r\n\r\n/* p {\r\n  font-size: 14px;\r\n  font-weight: 300;\r\n  line-height: 1.5;\r\n  color: #5b5b5b;\r\n} */\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n  font-weight: bold;\r\n  letter-spacing: -1px;\r\n}\r\n\r\nh1 {\r\n  color: #212121;\r\n  font-size: 2.8em;\r\n  margin: 24px 0;\r\n}\r\n\r\nh2 {\r\n  color: #353535;\r\n  font-size: 2.4em;\r\n  font-weight: bold;\r\n}\r\n\r\nh3 {\r\n  color: #484848;\r\n}\r\n\r\nh3,\r\nb,\r\nstrong {\r\n  font-weight: bold;\r\n}\r\n\r\n.custom-btn {\r\n  background: #eee;\r\n  color: #5b5b5b;\r\n  font-weight: bold;\r\n  border-radius: 50px;\r\n  padding: 13px 29px;\r\n  margin-right: 5px;\r\n  font-size: 14px;\r\n  line-height: normal;\r\n  overflow: hidden;\r\n  transition: all 0.4s ease;\r\n}\r\n\r\n.custom-btn:hover {\r\n  color: #1ABC9C;\r\n}\r\n\r\n.custom-btn.custom-btn-bg {\r\n  background: #474559;\r\n  color: #ffffff;\r\n}\r\n\r\n.custom-btn.custom-btn-bg:hover {\r\n  background: #1ABC9C;\r\n  color: #ffffff !important;\r\n}\r\n\r\n.animated {\r\n  position: relative;\r\n}\r\n\r\n.animated-info {\r\n  display: inline-block;\r\n  vertical-align: top;\r\n  margin-top: 5px;\r\n  min-width: 300px;\r\n  position: relative;\r\n}\r\n\r\n.animated-item {\r\n\r\n  color: #1ABC9C;\r\n\r\n}\r\n\r\n.animated-item  {\r\n  font-size: 38px;\r\n  line-height: inherit;\r\n  display: block;\r\n  opacity: 0;\r\n  overflow: hidden;\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0px;\r\n  left: 0;\r\n  animation: BottomTotop 6s linear infinite 0s;\r\n}\r\n\r\n/* .animated-item:nth-child(2n+2) {\r\n  animation-delay: 2s;\r\n} */\r\n\r\n/* .animated-item:nth-child(3n+3) {\r\n  animation-delay: 4s;\r\n} */\r\n\r\n/* @keyframes BottomTotop {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n\r\n  5% {\r\n    opacity: 0;\r\n    transform: translateY(5px);\r\n  }\r\n\r\n  10% {\r\n    opacity: 1;\r\n    transform: translateY(0px);\r\n  }\r\n\r\n  25% {\r\n    opacity: 1;\r\n    transform: translateY(0px);\r\n  }\r\n\r\n  30% {\r\n    opacity: 0;\r\n    transform: translateY(5px);\r\n  }\r\n\r\n  80% {\r\n    opacity: 0;\r\n  }\r\n\r\n  100% {\r\n    opacity: 0;\r\n  }\r\n} */\r\n\r\n.animated-item:nth-child(2) {\r\n  animation-delay: 3s; /* Delay for the second item */\r\n}\r\n\r\n@keyframes BottomTotop {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translateY(5px);\r\n  }\r\n\r\n  10% {\r\n    opacity: 1;\r\n    transform: translateY(0px);\r\n  }\r\n\r\n  30% {\r\n    opacity: 1;\r\n    transform: translateY(0px);\r\n  }\r\n\r\n  40% {\r\n    opacity: 0;\r\n    transform: translateY(5px);\r\n  }\r\n\r\n  100% {\r\n    opacity: 0;\r\n  }\r\n}\r\n.navbar {\r\n  background-color: white;\r\n  position: fixed !important;\r\n  top: 0;\r\n  right: 0;\r\n  left: 0;\r\n  z-index: 2;\r\n  will-change: transform;\r\n  transition: transform 200ms linear;\r\n  \r\n}\r\n\r\n.navbar[class*=\"-unpinned\"] {\r\n  transform: translate(0, -150%);\r\n}\r\n\r\n.navbar[class*=\"-pinned\"] {\r\n  transform: translate(0, 0);\r\n}\r\n\r\n.navbar[class*=\"headroom--not-top\"] {\r\n  background: #ffffff;\r\n  border-bottom: 1px solid #f0f0f0;\r\n  padding-top: 0;\r\n  padding-bottom: 0;\r\n}\r\n\r\n.navbar-brand {\r\n  font-weight: bold;\r\n\r\n}\r\n\r\n\r\n\r\n.navbar-brand {\r\n  background: #fff;\r\n  transition: all 0.5s;\r\n  z-index: 997;\r\n  padding: 20px 0;\r\n  padding-left: 35px;\r\n  top: 40px;\r\n}\r\n\r\n.navbar-brand .logo {\r\n  font-size: 25px;\r\n  margin: 0;\r\n\r\n  padding: 0;\r\n  line-height: 1;\r\n  font-weight: 700;\r\n  letter-spacing: 1px;\r\n  font-family: \"Raleway\", sans-serif;\r\n}\r\n\r\n.navbar-brand .logo span {\r\n  font-size: medium;\r\n}\r\n\r\n.navbar-brand .logo-text {\r\n  font-size: small;\r\n  color: #050505;\r\n  letter-spacing: 1px;\r\n  font-weight: 400;\r\n}\r\n\r\n.navbar-brand .logo {\r\n  color: #1ABC9C;\r\n}\r\n\r\n.navbar-brand .logo img {\r\n  max-height: 50px;\r\n  vertical-align: middle;\r\n  border-style: none;\r\n}\r\n\r\n@media (max-width: 992px) {\r\n  .navbar-brand {\r\n    top: 0;\r\n    padding: 15px 0;\r\n    padding-left: 35px;\r\n  }\r\n\r\n  .navbar-brand .logo {\r\n    font-size: 25px;\r\n  }\r\n}\r\n\r\n@media (max-width: 576) {\r\n  .navbar-brand {\r\n    top: 0;\r\n    padding: 15px 0;\r\n    padding-left: 35px;\r\n  }\r\n\r\n  .navbar-brand .logo {\r\n    font-size: 10px;\r\n  }\r\n}\r\n\r\n.navbar-expand-sm .navbar-nav .nav-link {\r\n  padding: 0 20px;\r\n}\r\n\r\n.nav-link {\r\n  font-weight: bold;\r\n  font-size: 16px;\r\n  overflow: hidden;\r\n}\r\n\r\n\r\n.nav-link span {\r\n  position: relative;\r\n  display: inline-block;\r\n  transition: transform 0.3s;\r\n}\r\n\r\n.nav-link span:before {\r\n  position: absolute;\r\n  top: 100%;\r\n  content: attr(data-hover);\r\n  transform: translate3d(0, 0, 0);\r\n}\r\n\r\n.navbar-light .navbar-nav .nav-link:focus,\r\n.navbar-light .navbar-nav .nav-link:hover {\r\n\r\n  font-weight: bold;\r\n}\r\n\r\n.navbar-light .navbar-nav .nav-link:focus span,\r\n.navbar-light .navbar-nav .nav-link:hover span {\r\n  transform: translateY(-100%);\r\n}\r\n\r\n.navbar-light .navbar-toggler-icon {\r\n  background: none;\r\n}\r\n\r\n.navbar-toggler {\r\n  border: 0;\r\n  padding: 0;\r\n  width: 32px;\r\n  height: 32px;\r\n  line-height: 32px;\r\n  outline: none;\r\n  cursor: pointer;\r\n  margin-right: 10px;\r\n}\r\n\r\n.navbar-toggler:focus {\r\n  outline: none;\r\n}\r\n\r\n.navbar-toggler[aria-expanded=\"true\"] .navbar-toggler-icon:first-child {\r\n  transform: rotate(45deg);\r\n  top: 6px;\r\n}\r\n\r\n.navbar-toggler[aria-expanded=\"true\"] .navbar-toggler-icon:nth-child(2) {\r\n  display: none;\r\n}\r\n\r\n.navbar-toggler[aria-expanded=\"true\"] .navbar-toggler-icon:last-child {\r\n  transform: rotate(-45deg);\r\n  bottom: 1px;\r\n}\r\n\r\n.navbar-toggler .navbar-toggler-icon {\r\n  background: #212121;\r\n  display: block;\r\n  width: 100%;\r\n  height: 2px;\r\n  margin: 5px 0;\r\n  transition: all 0.4s ease;\r\n  position: relative;\r\n}\r\n\r\n\r\n\r\n.close-navbar-toggler {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  height: 100%;\r\n  width: 100%;\r\n  z-index: 1;\r\n  cursor: pointer;\r\n}\r\n\r\n.close-navbar-toggler.collapsed {\r\n  z-index: -1;\r\n}\r\n\r\n.copyright-text {\r\n  font-size: 16px;\r\n\r\n  font-weight: normal;\r\n  display: block;\r\n  margin-top: auto;\r\n}\r\n\r\n.color-mode {\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n}\r\n\r\n.color-mode-icon {\r\n  position: relative;\r\n  right: 6px;\r\n}\r\n\r\n.color-mode-icon:after {\r\n  font-family: 'unicons';\r\n  content: '\\ea9f';\r\n  font-size: 30px;\r\n  font-weight: 300;\r\n  font-style: normal;\r\n}\r\n\r\n.color-mode-icon.active:after {\r\n  font-family: 'unicons';\r\n  content: '\\eb65';\r\n  font-size: 30px;\r\n  color: #ffffff;\r\n}\r\n\r\n.dark-mode {\r\n  background: #0c0c0d;\r\n}\r\n\r\n.dark-mode .navbar-light .navbar-nav .nav-link {\r\n  color: rgba(255, 255, 255, 0.8);\r\n}\r\n\r\n\r\n.dark-mode .navbar[class*=\"headroom--not-top\"] {\r\n  background: #0c0c0d;\r\n  border-bottom: 1px solid #1f1f1f;\r\n}\r\n\r\n.dark-mode .small-text {\r\n  background: #0d0c15;\r\n  color: #ffffff;\r\n}\r\n\r\n.dark-mode .feature-card .uil,\r\n.dark-mode .navbar-light .navbar-brand,\r\n.dark-mode h1,\r\n.dark-mode h2,\r\n.dark-mode h3,\r\n.dark-mode h4,\r\n.dark-mode h5,\r\n.dark-mode h6,\r\n.dark-mode .color-mode {\r\n  color: #ffffff;\r\n}\r\n\r\n.dark-mode .owl-carousel .owl-nav button.owl-next,\r\n.dark-mode .owl-carousel .owl-nav button.owl-prev,\r\n.dark-mode .owl-carousel button.owl-dot {\r\n  color: #ffffff;\r\n}\r\n\r\n.timeline-wrapper {\r\n  position: relative;\r\n  padding: 22px 0;\r\n}\r\n\r\n.timeline-wrapper:last-child:before {\r\n  height: 0;\r\n}\r\n\r\n.timeline-wrapper:before {\r\n  content: \"\";\r\n  background: #474559;\r\n  width: 3px;\r\n  height: 100%;\r\n  position: absolute;\r\n  left: 38px;\r\n}\r\n\r\n.timeline-yr {\r\n  background: #474559;\r\n  border-radius: 100%;\r\n  position: absolute;\r\n  width: 75px;\r\n  height: 75px;\r\n  line-height: 75px;\r\n  text-align: center;\r\n}\r\n\r\n.timeline-yr span {\r\n  color: #ffffff;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  display: block;\r\n  line-height: 75px;\r\n}\r\n\r\n.timeline-info {\r\n  display: inline-block;\r\n  vertical-align: top;\r\n  max-width: 432px;\r\n  margin-left: 6em;\r\n}\r\n\r\n.timeline-info small {\r\n  color: #474559;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  margin-left: 15px;\r\n}\r\n\r\n.owl-carousel .owl-nav span {\r\n  display: none;\r\n}\r\n\r\n.owl-carousel .owl-nav .owl-prev:before,\r\n.owl-carousel .owl-nav .owl-next:before {\r\n  background: none;\r\n  padding: 0;\r\n  display: block;\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translate(0, -50%);\r\n  font-family: 'unicons';\r\n  font-size: 100px;\r\n  line-height: normal;\r\n}\r\n\r\n.owl-carousel .owl-nav .owl-prev:before {\r\n  content: '\\e833';\r\n  left: -45px;\r\n}\r\n\r\n.owl-carousel .owl-nav .owl-next:before {\r\n  content: '\\e836';\r\n  right: -45px;\r\n}\r\n\r\n.owl-theme .owl-nav [class*=owl-] {\r\n  background: none;\r\n  border-radius: 0;\r\n  margin: 0;\r\n  padding: 0;\r\n  font-size: inherit;\r\n}\r\n\r\n.owl-theme .owl-nav [class*=owl-]:hover {\r\n\r\n  color: #1ABC9C;\r\n\r\n}\r\n\r\n.owl-theme .owl-dots .owl-dot {\r\n  outline: none;\r\n}\r\n\r\n.owl-theme .owl-dots .owl-dot span {\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n.owl-theme .owl-dots .owl-dot.active span,\r\n.owl-theme .owl-dots .owl-dot:hover span {\r\n  background: #5b5b5b;\r\n}\r\n\r\n.google-map iframe {\r\n  width: 100%;\r\n}\r\n\r\n.contact-form {\r\n  position: relative;\r\n}\r\n\r\n.contact-form .form-control {\r\n  background: transparent;\r\n  border-radius: -20px;\r\n  outline: none;\r\n  box-shadow: none;\r\n  font-weight: 300;\r\n  margin: 4px 0;\r\n  align-items: center;\r\n\r\n\r\n}\r\n\r\n.contact-form .form-control:not(textarea) {\r\n  height: 40px;\r\n}\r\n\r\n.contact-form .form-control:hover,\r\n.contact-form .form-control:focus {\r\n  color: #1ABC9C;\r\n\r\n  border-radius: -20px;\r\n\r\n}\r\n\r\n.contact-form .submit-btn {\r\n  background: #1ABC9C;\r\n border-radius: 50px;\r\n  color: #ffffff;\r\n  font-weight: bold;\r\n  border: 0;\r\n  cursor: pointer;\r\n  transition: all 0.4s ease;\r\n}\r\n\r\n.contact-form .submit-btn:hover {\r\n  background: #474559;\r\n}\r\n\r\n.contact-form labels {\r\n  margin-right: 0px;\r\n  justify-content: flex-start;\r\n  color: #1ABC9C;\r\n\r\n}\r\n\r\n.contact-info {\r\n  background: #474559;\r\n  border-radius: 0 0 3px 3px;\r\n  position: relative;\r\n  bottom: 8px;\r\n}\r\n\r\n.contact-info p,\r\n.contact-info a {\r\n  color: #f7f3f3;\r\n}\r\n\r\n.social-links .uil {\r\n  color: #f7f3f3;\r\n  font-size: 20px;\r\n  display: block;\r\n  margin: 5px 0;\r\n}\r\n\r\n.social-links .uil:hover {\r\n  color: #1ABC9C;\r\n\r\n}\r\n\r\n@media (min-width: 1270px) {\r\n  .owl-theme .owl-dots {\r\n    position: relative;\r\n    bottom: 50px;\r\n  }\r\n}\r\n\r\n@media (max-width: 991px) {\r\n  .full-screen {\r\n    padding-bottom: 4rem;\r\n  }\r\n\r\n  .color-mode {\r\n    display: none;\r\n  }\r\n\r\n  .about-image {\r\n    margin-top: 4em;\r\n  }\r\n\r\n  .mobile-mt-2,\r\n  .contact-form {\r\n    margin-top: 4em;\r\n  }\r\n\r\n  .contact-info {\r\n    padding: 0 2rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  h1 {\r\n    font-size: 2.4em;\r\n  }\r\n\r\n  h2 {\r\n    font-size: 2em;\r\n  }\r\n\r\n  .animated-item {\r\n    font-size: 28px;\r\n  }\r\n\r\n  .navbar-collapse {\r\n    text-align: center;\r\n    padding-bottom: 20px;\r\n  }\r\n\r\n  .navbar-expand-sm .navbar-nav .nav-link {\r\n    padding: 3px 20px;\r\n  }\r\n}\r\n\r\n@media (max-width: 580px) {\r\n  .animated-info {\r\n    min-width: 200px;\r\n  }\r\n\r\n  .animated-item {\r\n    font-size: 30px;\r\n  }\r\n\r\n  .custom-btn-group {\r\n    text-align: center;\r\n  }\r\n\r\n  .custom-btn {\r\n    display: block;\r\n    margin: 10px 0;\r\n  }\r\n\r\n  .submit-btn {\r\n    text-align: center;\r\n    position: relative;\r\n  }\r\n\r\n  .owl-theme .owl-nav {\r\n    display: none;\r\n  }\r\n\r\n  .timeline-info small {\r\n    display: block;\r\n    margin: 10px 0 0 0;\r\n  }\r\n}\r\n\r\n@media (max-width: 320px) {\r\n  .animated-text {\r\n    margin-top: 0;\r\n  }\r\n\r\n  .submit-btn {\r\n    text-align: center;\r\n    position: relative;\r\n  }\r\n\r\n  .about-text {\r\n    text-align: center;\r\n  }\r\n\r\n  .full-screen {\r\n    padding: 4rem 0;\r\n  }\r\n\r\n  .mobile-block {\r\n    display: block;\r\n  }\r\n\r\n  .contact-info {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .social-links li {\r\n    display: inline-block;\r\n    vertical-align: top;\r\n  }\r\n}\r\n\r\n\r\n.navbar-scrolled {\r\n  background-color: #eabdbd;\r\n}\r\n\r\n\r\n@media (max-width: 576px) {\r\n  .pagination-container button {\r\n    font-size: 0.8rem;\r\n    padding: 0.2rem 0.4rem;\r\n  }\r\n}\r\n\r\n\r\n.btn-green {\r\n  background-color: #1ABC9C;\r\n  color: white;\r\n  text-wrap: nowrap;\r\n}\r\n.btn-secondary{\r\n  text-wrap: nowrap;\r\n}\r\n\r\n.btn-green:hover {\r\n  background-color: #2dceae;\r\n  color: white;\r\n}\r\n\r\n.text-green {\r\n  color: #1ABC9C;\r\n\r\n}\r\n.bk-hr{\r\n    background-color:#474559 !important;\r\n    color: #fff !important;\r\n    border: 2px solid white;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    font-weight: bold;\r\n    font-size: large;\r\n    margin-top: 8px;\r\n    display: block;\r\n\r\n}\r\n\r\n.button-container {\r\n  position: relative;\r\n}\r\n\r\n.bt-l {\r\n  position: absolute;\r\n  right: 0;\r\n}\r\n.button-spacing{\r\n  margin-right: 8px !important;\r\n}\r\n .form-control-bg{\r\n  background-color: #FFFFFF !important; \r\n \r\n}\r\n.table-responsive-resume table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\n\r\n.table-responsive-resume td {\r\n  padding: 10px;\r\n  text-align: left;\r\n  vertical-align: top;\r\n  text-wrap: wrap !important;\r\n\r\n}\r\n.table-responsive-resume th{\r\n  padding: 10px;\r\n  text-align: left;\r\n  vertical-align: top;\r\n  text-wrap: nowrap;\r\n  }\r\n.table-responsive-resume td{\r\n  word-break: break-word;\r\n}\r\n@media (max-width: 768px) {\r\n  .table-responsive-resume th,\r\n  .table-responsive-resume td {\r\n    display: block;\r\n    width: 100%;\r\n  }\r\n\r\n  .table-responsive-resume th {\r\n    font-weight: bold;\r\n    background-color: #f8f9fa;\r\n    border-bottom: 1px solid #dee2e6;\r\n  }\r\n\r\n  .table-responsive-resume td {\r\n    margin-bottom: 10px;\r\n    text-align: justify;\r\n  }\r\n}\r\n.table-responsive-resume td{\r\n  text-align: justify;\r\n}\r\n\r\n@media (min-width: 768px) and (max-width: 1024px) {\r\n  body{\r\n    margin-top: 28px !important;\r\n  }\r\n}\r\n\r\n.form-check-input:checked{\r\n  background-color: #1ABC9C;\r\n    border-color: #1ABC9C;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
